<template>
  <div ref="backgroundElement" class="polygon-background">
    <slot />

    <div class="polygon-background__background" aria-hidden="true">
      <svg
        class="a-visually-hidden"
        viewBox="0 0 923 810"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <path
            id="polygon"
            stroke="#bb9b61"
            stroke-width="7"
            vector-effect="non-scaling-stroke"
            d="M1.70285 503.995L276.702 1.5H645.36L921.296 503.995L759.995 808.5H162.379L1.70285 503.995Z"
          />
        </defs>

        <clipPath id="polygon-clip" clipPathUnits="objectBoundingBox">
          <path
            transform="scale(0.00108342,0.00123457)"
            stroke="#bb9b61"
            stroke-width="7"
            vector-effect="non-scaling-stroke"
            d="M1.70285 503.995L276.702 1.5H645.36L921.296 503.995L759.995 808.5H162.379L1.70285 503.995Z"
          />
        </clipPath>
      </svg>

      <div ref="backgroundContentElement">
        <!-- :nth-child(1) -->
        <svg
          class="polygon-background__polygon polygon"
          viewBox="0 0 923 810"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use href="#polygon" clip-path="url(#polygon-clip)" />
        </svg>
        <!-- :nth-child(2) -->
        <svg
          class="polygon-background__polygon polygon"
          viewBox="0 0 923 810"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use href="#polygon" clip-path="url(#polygon-clip)" />
        </svg>
        <!-- :nth-child(3) -->
        <svg
          class="polygon-background__polygon polygon"
          viewBox="0 0 923 810"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use href="#polygon" clip-path="url(#polygon-clip)" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { useMove } from '@vueuse/gesture';
import { useMotionProperties, useSpring } from '@vueuse/motion';
import {
  useElementBounding,
  useMouse,
  useWindowScroll,
  usePointer,
} from '@vueuse/core';
import { ref, computed, watchEffect } from 'vue';

export default {
  setup() {
    const { y: windowY } = useWindowScroll();
    const { y: mouseY } = useMouse();
    const { pointerType } = usePointer();

    const isEffectEnabled = computed(() => {
      return pointerType.value === 'mouse' && mouseInRange.value;
    });

    const mouseInRange = computed(() => {
      return (
        mouseY.value <= boundingBackgroundElement.bottom.value + windowY.value
      );
    });

    const backgroundElement = ref(undefined);
    const boundingBackgroundElement = useElementBounding(backgroundElement);

    const backgroundContentElement = ref(undefined);

    const { motionProperties } = useMotionProperties(backgroundContentElement, {
      x: 1,
      y: 1,
    });

    const { set } = useSpring(motionProperties, {
      damping: 40,
      stiffness: 200,
      mass: 0.2,
    });

    useMove(
      ({ event, moving, hovering }) => {
        if (!isEffectEnabled.value) return;

        const x =
          event.pageX -
          boundingBackgroundElement.left.value -
          boundingBackgroundElement.width.value / 2;

        const y =
          event.pageY -
          boundingBackgroundElement.top.value -
          boundingBackgroundElement.height.value / 2;

        set({
          x,
          y,
        });
      },
      {
        domTarget: document.querySelector('body'),
      }
    );

    watchEffect(() => {
      if (!isEffectEnabled.value) set({ x: 0, y: 0 });
    });

    return {
      backgroundElement,
      backgroundContentElement,
      mouseY,
      boundingBackgroundElement,
    };
  },
};
</script>
